import { action, Action } from 'easy-peasy';
import cloneDeep from 'lodash/cloneDeep';
import { ISizeList } from '@/services/size-list/index.d';

export interface IStageSizeCollapse {
    // 常用素材列表
    stageSizeList: ISizeList[];
    setStageSizeList: Action<IStageSizeCollapse, ISizeList[]>;
}

export const stageSizeCollapseModel: IStageSizeCollapse = {
    stageSizeList: [],
    setStageSizeList: action((state, list) => {
        state.stageSizeList = cloneDeep(list);
    }),
};
